import { FC } from 'react'
import { RenderIf } from 'components/RenderIf'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { IProduct } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'
import { convertToPrice } from 'featureSliced/shared/utils/convertToPrice'
import { useGetProductPrice } from 'featureSliced/shared/hooks/useGetProductPrice/indexT'

import {
  CutDisclaimer,
  PriceInfoContainer,
  ProductSellCodePrice,
  UnitSellCodePriceContainer,
} from './styled'

type TitleAndPriceProps = {
  product: IProduct
  currentAmount: number
}

export const UnitSellCodePrice: FC<TitleAndPriceProps> = ({
  product,
  currentAmount,
}) => {
  // Hooks
  const t = useTranslations()
  const { getProductPrice } = useGetProductPrice()

  // Store
  const Currency = useMySelector((state) => state.app.companyData.Currency)

  const { finalPriceString, finalPrice } = getProductPrice(
    product,
    product?.categoryId
  )

  return (
    <RenderIf
      condition={product.unitSellCode === 2 || product.unitSellCode === 3}
    >
      <UnitSellCodePriceContainer>
        <p>
          {product.unitSellCode === 2 ? '100g' : ''}
          {product.unitSellCode === 3 ? '1kg' : ''}
        </p>
        <p> = </p>
        <p>
          {finalPriceString}&thinsp;
          {Currency || ''}
        </p>
        <PriceInfoContainer>
          <ProductSellCodePrice>
            {convertToPrice(finalPrice * currentAmount)}&thinsp;
            {Currency || ''}
          </ProductSellCodePrice>
        </PriceInfoContainer>
      </UnitSellCodePriceContainer>
      <CutDisclaimer>{t('products.cutDisclaimer')}</CutDisclaimer>
    </RenderIf>
  )
}
